import translations from "@/config/translations";
import useLangStore from "@/hooks/useLangStore";
import type { ReactNode } from "react";
import { useState } from "react";
import { NavLink } from "react-router-dom";
import "./styles.css";

export interface ActionsBarTab {
    label: string;
    path: string;
    end?: boolean;
}

export interface ActionsBarExtraAction {
    name: string;
    handler: () => void;
    children: ReactNode;
}

export interface ActionsBarProps {
    tabs?: ActionsBarTab[];
    onAdd?: () => void;
    addLabel?: string;
    filterContent?: ReactNode;
    extraActions?: ActionsBarExtraAction[];
}

export default function ActionsBar({ tabs, onAdd, addLabel, filterContent, extraActions }: ActionsBarProps) {
    const { lang } = useLangStore();
    const t = translations[lang ?? "ar"];
    const [filtersOpen, setFiltersOpen] = useState(false);

    // const hasFilter = filterContent !== undefined && filterContent !== null;

    return (
        <div className="actions-bar">
            {filtersOpen ? (
                <div className="actions-bar-filter-mode">
                    <button
                        className="actions-bar-cancel-btn"
                        onClick={() => setFiltersOpen(false)}
                        type="button"
                        aria-label={t.actionsBar.closeFilter}
                    >
                        ×
                    </button>
                    <div className="actions-bar-filter-content">{filterContent}</div>
                </div>
            ) : (
                <>
                    {tabs && tabs.length > 0 && (
                        <nav className="actions-bar-tabs">
                            {tabs.map((tab) => (
                                <NavLink
                                    key={tab.path}
                                    to={tab.path}
                                    end={tab.end}
                                    className={({ isActive }) => `actions-bar-tab${isActive ? " actions-bar-tab--active" : ""}`}
                                >
                                    {tab.label}
                                </NavLink>
                            ))}
                        </nav>
                    )}
                    <div className="actions-bar-spacer" />
                    <div className="actions-bar-actions">
                        {/* {hasFilter && (
                            <button
                                className="actions-bar-filter-btn"
                                onClick={() => setFiltersOpen(true)}
                                type="button"
                                aria-label={t.actionsBar.filter}
                            >
                                <img src="/icons/filter-icon.svg" alt="" width={18} height={18} />
                            </button>
                        )} */}
                        {extraActions?.map((action) => (
                            <button key={action.name} onClick={action.handler} type="button" className="actions-bar-extra-btn">
                                {action.children}
                            </button>
                        ))}
                        {onAdd && (
                            <button className="actions-bar-add-btn" onClick={onAdd} type="button">
                                <span>{addLabel ?? t.actionsBar.add}</span>
                                <img src="/icons/plus-icon.svg" alt="" width={12} height={12} />
                            </button>
                        )}
                    </div>
                </>
            )}
        </div>
    );
}
